import { css } from 'astroturf';
import React from 'react';

const styles = css`
  .featurestrip {
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto 10rem;
  }

  .featurestrip h2 {
    text-align: center;
    font-size: 1.5rem;
  }

  .features {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .feature {
    text-align: center;
    flex: 1 1 220px;
  }

  .icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 8px;
    border-radius: 18px;
    display: grid;
    place-items: center;
  }

  .icon svg {
    width: 34px;
    height: 34px;

    stroke: #1583d8;
    stroke-width: 1.7;

    fill: none;

    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .feature h3 {
    margin-bottom: 10px;
    font-size: 1rem;
    line-height: 1;
  }

  .feature p {
    color: #667085;
    font-size: 0.875rem;
    line-height: 1.5;
  }
`;

const Features = () => {
  const nope = '';

  return (
    <section className={styles.featurestrip}>
      <h2>Every subscription includes all development features</h2>

      <div className={styles.features}>
        <article className={styles.feature}>
          <div className={styles.icon}>
            <svg viewBox="0 0 24 24">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <line x1="10" y1="5" x2="10" y2="19" />
              <line x1="16" y1="5" x2="16" y2="19" />
            </svg>
          </div>

          <h3>Unlimited synchronized panes</h3>

          <p>Test across multiple viewports in real time.</p>
        </article>

        <article className={styles.feature}>
          <div className={styles.icon}>
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="5" r="2" />
              <line x1="12" y1="7" x2="12" y2="19" />
              <line x1="6" y1="10" x2="18" y2="10" />
              <line x1="12" y1="19" x2="8" y2="23" />
              <line x1="12" y1="19" x2="16" y2="23" />
            </svg>
          </div>

          <h3>Accessibility auditing</h3>

          <p>Catch issues early with automated and manual audits.</p>
        </article>

        <article className={styles.feature}>
          <div className={styles.icon}>
            <svg viewBox="0 0 24 24">
              <rect x="3" y="7" width="18" height="12" rx="2" />
              <circle cx="12" cy="13" r="3" />
              <path d="M8 7l1.2-2h5.6L16 7" />
            </svg>
          </div>

          <h3>Screenshots and Recordings</h3>

          <p>Create, annotate and share screenshots and recordings in one click.</p>
        </article>

        <article className={styles.feature}>
          <div className={styles.icon}>
            <svg viewBox="0 0 24 24">
              <rect x="2" y="5" width="10" height="14" rx="1" />
              <rect x="15" y="3" width="7" height="18" rx="1" />
            </svg>
          </div>

          <h3>Device emulation</h3>

          <p>Realistic emulation of devices, browsers, input methods and network.</p>
        </article>

        <article className={styles.feature}>
          <div className={styles.icon}>
            <svg viewBox="0 0 24 24">
              <path d="M20 7v5h-5" />
              <path d="M20 12a8 8 0 1 1-2.3-5.7" />
            </svg>
          </div>

          <h3>Live reload</h3>

          <p>See changes instantly and debug like a pro.</p>
        </article>

        <article className={styles.feature}>
          <div className={styles.icon}>
            <svg viewBox="0 0 24 24">
              <circle cx="10" cy="10" r="6" />
              <line x1="15" y1="15" x2="21" y2="21" />
            </svg>
          </div>

          <h3>SEO &amp; quality checks</h3>

          <p>Check SEO, metadata and performance before launch.</p>
        </article>
      </div>
    </section>
  );
};

export default Features;
